import { useState, useEffect } from 'react';
import { X, Sparkles } from 'lucide-react';
import axios from 'axios';

const API_V2 = `${process.env.REACT_APP_BACKEND_URL}/api/v2`;
const SHOW_DAYS = 7;

const WhatsNewCard = () => {
  const [visible, setVisible] = useState(false);
  const [version, setVersion] = useState('');
  const [headline, setHeadline] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API_V2}/changelog`, { timeout: 5000 });
        const data = res.data;
        const current = data?.current;
        const latest = data?.versions?.[0];
        if (!current || !latest) return;

        // Check if dismissed for this version
        const dismissKey = `bitbot_whats_new_dismissed_v${current}`;
        if (localStorage.getItem(dismissKey)) return;

        // Check if within 7 days of release
        const releaseDate = new Date(latest.date);
        const daysSince = (new Date() - releaseDate) / (1000 * 60 * 60 * 24);
        if (daysSince > SHOW_DAYS) return;

        setVersion(current);
        setHeadline(latest.title || latest.changes?.[0] || 'New updates available');
        setVisible(true);
      } catch {}
    })();
  }, []);

  const dismiss = () => {
    localStorage.setItem(`bitbot_whats_new_dismissed_v${version}`, Date.now().toString());
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-16 left-5 z-40" data-testid="whats-new-card">
      <div className="bg-[#0a0a0a] border border-[#00FF41]/50 shadow-[0_0_25px_rgba(0,255,65,0.15)] rounded-sm overflow-hidden max-w-[280px]">
        <div className="h-1 bg-gradient-to-r from-[#00FF41] via-[#00FF41] to-red-500" />
        <div className="p-3">
          <div className="flex items-start justify-between mb-2">
            <div className="flex items-center gap-1.5">
              <Sparkles className="h-3.5 w-3.5 text-[#00FF41]" />
              <span className="text-xs font-bold text-[#00FF41] uppercase tracking-wider">What's New</span>
              <span className="text-[9px] font-mono text-gray-500 ml-1">v{version}</span>
            </div>
            <button
              onClick={dismiss}
              className="text-gray-600 hover:text-white transition-colors -mt-0.5 -mr-0.5 p-0.5"
              data-testid="whats-new-dismiss"
            >
              <X className="h-3.5 w-3.5" />
            </button>
          </div>
          <p className="text-sm text-gray-300 leading-snug mb-2.5">{headline}</p>
          <a
            href="/changelog"
            className="inline-flex items-center gap-1 text-xs text-[#00FF41] hover:text-white font-semibold tracking-wide uppercase transition-colors"
            data-testid="whats-new-link"
          >
            See full changelog &rarr;
          </a>
        </div>
      </div>
    </div>
  );
};

export default WhatsNewCard;
